module.exports = __webpack_public_path__ + "static/img/paymentplan.931f4a8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/color/color-3/paymentplan.png
// module id = oWNs
// module chunks = 0